import { DateTime, Duration } from 'luxon'

export const getDurationBetweenTwoDatesUtils = (startDate: DateTime, endDate: DateTime): Duration | null =>
    startDate && startDate.isValid && endDate && endDate.isValid
        ? endDate.diff(startDate, ['hours', 'minutes', 'seconds'])
        : null

export const getDurationBetweenTwoStringDatesUtils = (startDate: string, endDate: string): number | null => {
    const startDateLuxon = DateTime.fromISO(startDate)
    const endDateLuxon = DateTime.fromISO(endDate)
    const duration =
        startDateLuxon && startDateLuxon.isValid && endDateLuxon && endDateLuxon.isValid
            ? endDateLuxon.diff(startDateLuxon, ['hours'])
            : 0
    return duration && duration.isValid ? Number(duration.hours.toFixed(2)) : null
}
